<template>
    <div class="justify-content-center">
        <img
            alt="Ideasfundx logo"
            src="../../../../assets/img/m-4.png"
            class=""
        />
        <div class="mt-3">
            <v-row>
                <v-col cols="12" sm="4" class="mb-0 p-0">
                    <p class="text-sm-left mt-2 mb-0">
                        <b>Previous external financing in USD</b>
                    </p>
                </v-col>
                <v-col cols="12" sm="6">
                    <v-text-field
                        v-model="investment_finance"
                        class="text-bold text-right-input"
                        outlined
                        dense
                        placeholder="..."
                        disabled
                    />
                </v-col>
            </v-row>

            <div class="text-left">
                <b style="color:#000">Details</b>
            </div>

            <v-row class="my-0" v-if="investment_equity != 0">
                <v-col cols="12" sm="4" class="mb-0 p-0">
                    <p class="text-sm-left font-weight-light mt-2 ml-5 p-0 my-0" style="color: #000;">Equity</p>
                </v-col>
                <v-col cols="12" sm="6" class="my-0 py-0">
                    <v-text-field
                        v-model="investment_equity"
                        class="text-bold text-right-input"
                        placeholder="..."
                        outlined
                        dense
                        disabled
                    />
                </v-col>
            </v-row>

            <v-row class="my-0" v-if="investment_convertible != 0">
                <v-col cols="12" sm="4" class="mb-0 p-0">
                    <p class="text-sm-left font-weight-light mt-2 ml-5 my-0" style="color: #000;">Convertible note</p>
                </v-col>
                <v-col cols="12" sm="6" class="my-0 py-0">
                    <v-text-field
                        v-model="investment_convertible"
                        class="text-bold text-right-input"
                        placeholder="..."
                        outlined
                        dense
                        disabled
                    />
                </v-col>
            </v-row>

            <v-row class="my-0" v-if="investment_safe != 0">
                <v-col cols="12" sm="4" class="mb-0 p-0">
                    <p class="text-sm-left font-weight-light mt-2 ml-5 my-0" style="color: #000;">SAFE</p>
                </v-col>
                <v-col cols="12" sm="6" class="py-0">
                    <v-text-field
                        v-model="investment_safe"
                        class="text-bold text-right-input"
                        placeholder="......"
                        outlined
                        dense
                        disabled
                    />
                </v-col>
            </v-row>

            <v-row class="my-0" v-if="investment_bonds != 0">
                <v-col cols="12" sm="4" class="mb-0 p-0">
                    <p class="text-sm-left font-weight-light mt-2 ml-5 my-0" style="color: #000;">Bonds</p>
                </v-col>
                <v-col cols="12" sm="6" class="my-0 py-0">
                    <v-text-field
                        v-model="investment_bonds"
                        class="text-bold text-right-input"
                        placeholder="..."
                        outlined
                        dense
                        disabled
                    />
                </v-col>
            </v-row>

            <v-row class="my-0" v-if="investment_bank != 0">
                <v-col cols="12" sm="4" class="mb-0 p-0">
                    <p class="text-sm-left font-weight-light mt-2 ml-5 my-0 py-0" style="color: #000;">Bank Loans</p>
                </v-col>
                <v-col cols="12" sm="6" class="my-0 py-0">
                    <v-text-field
                        v-model="investment_bank"
                        class="text-bold text-right-input"
                        placeholder="..."
                        outlined
                        dense
                        disabled
                    />
                </v-col>
            </v-row>

            <v-row class="my-0" v-if="investment_grants != 0">
                <v-col cols="12" sm="4" class="p-0">
                    <p class="text-sm-left font-weight-light mt-2 ml-5 my-0" style="color: #000;">Grants</p>
                </v-col>
                <v-col cols="12" sm="6" class="py-0">
                    <v-text-field
                        v-model="investment_grants"
                        class="text-bold text-right-input"
                        placeholder="..."
                        outlined
                        dense
                        disabled
                    />
                </v-col>
            </v-row>


            <!-- //skksks -->
            <v-row class="my-0" v-if="result_monthlyRevenue != 0">
                <v-col cols="12" sm="4" class="py-0">
                    <p class="text-sm-left my-0 py-0">
                        <b>Monthly Recurring Revenue in USD</b>
                        <span class="font-weight-thin text-black"> in the last semester </span>
                    </p>
                </v-col>
                <v-col cols="12" sm="6" class="py-0">
                    <v-text-field
                        v-model="result_monthlyRevenue"
                        class="text-bold text-right-input"
                        placeholder="......"
                        outlined
                        dense
                        disabled
                    />
                </v-col>
            </v-row>

            <v-row class="my-0" v-if="result_postMoneyValuation != 0">
                <v-col cols="12" sm="4" class="pt-2">
                    <p class="text-sm-left my-0 py-0">
                        <b>Share post-money valuation in USD.</b>
                    </p>
                </v-col>
                <v-col cols="12" sm="6" class="py-0">
                    <v-text-field
                        v-model="result_postMoneyValuation"
                        class="text-bold text-right-input"
                        placeholder="......"
                        outlined
                        dense
                        disabled
                    />
                </v-col>
            </v-row>

            <v-row class="my-0">
                <v-col cols="12" md="10" class="py-0">
                    <v-col cols="12" class="text-left ml-0 pl-0 py-0">
                        <b>Past results</b> <span class="text-sm-left blue-grey--text text--lighten-2 thin mt-5 my-0">Unit : USD K</span>
                    </v-col>
                    <v-row>
                        <v-col cols="12" sm="3" class="d-none d-sm-block">
                            <p class="text-sm-left mt-14 font-weight-light text-black">Annual revenues</p>
                            <p class="text-sm-left mt-13 font-weight-light text-black">EBITDA</p>
                        </v-col>

                        <!-- First year -->

                        <v-col cols="12" sm="3" style="margin-left:" class="py-0" v-if="result.firstYear.year">
                            <div class="text-left d-block d-sm-none mt-3">
                                <p class="m-0">First Year</p>
                            </div>
                            <v-text-field
                                v-model="result.firstYear.year"
                                class="years"
                                background-color="grey"
                                placeholder="...."
                                outlined
                                dense
                                disabled
                            />
                            <div style="position: relative;">
                                <p class="text-sm-left font-weight-light text-black m-0 d-block d-sm-none">Annual revenues</p>
                                <v-text-field
                                    v-model="result_firstYear_annualRevenues"
                                    class="text-bold text-right-input"
                                    outlined
                                    dense
                                    disabled
                                />
                            </div>

                            <div style="position: relative;">
                                <p class="text-sm-left font-weight-light text-black m-0 d-block d-sm-none">EBITDA</p>
                                <v-text-field
                                    v-model="result_firstYear_ebitda"
                                    class="text-bold text-right-input"
                                    outlined
                                    dense
                                    disabled
                                />
                            </div>
                        </v-col>

                        <!-- Second year -->

                        <v-col cols="12" sm="3" class="my-0 py-0" v-if="result.secondYear.year">
                            <div class="text-left d-block d-sm-none">
                                <p class="m-0">Second Year</p>
                            </div>
                            <v-text-field
                                v-model="result.secondYear.year"
                                class="years"
                                background-color="grey"
                                placeholder="...."
                                outlined
                                dense
                                disabled
                            />

                            <div style="position: relative;">
                                <p class="text-sm-left font-weight-light text-black m-0 d-block d-sm-none">Annual revenues</p>
                                <v-text-field
                                    v-model="result_secondYear_annualRevenues"
                                    class="text-bold text-right-input"
                                    outlined
                                    dense
                                    disabled
                                />
                            </div>

                            <div style="position: relative;">
                                <p class="text-sm-left font-weight-light text-black m-0 d-block d-sm-none">EBITDA</p>
                                <v-text-field
                                    v-model="result_secondYear_ebitda"
                                    class="text-bold text-right-input"
                                    outlined
                                    dense
                                    disabled
                                />
                            </div>
                        </v-col>

                        <!-- Third year -->

                        <v-col cols="12" sm="3" class="py-0" v-if="result.thirdYear.year">
                            <div class="text-left d-block d-sm-none">
                                <p class="m-0">Third Year</p>
                            </div>
                            <v-text-field
                                v-model="result.thirdYear.year"
                                class="years"
                                background-color="grey"
                                placeholder="...."
                                outlined
                                dense
                                disabled
                            />

                            <div style="position: relative;">
                                <p class="text-sm-left font-weight-light text-black m-0 d-block d-sm-none">Annual revenues</p>
                                <v-text-field
                                    v-model="result_thirdYear_annualRevenues"
                                    class="text-bold text-right-input"
                                    outlined
                                    dense
                                    disabled
                                />
                            </div>

                            <div style="position: relative;">
                                <p class="text-sm-left font-weight-light text-black m-0 d-block d-sm-none">EBITDA</p>
                                <v-text-field
                                    v-model="result_thirdYear_ebitda"
                                    class="text-bold text-right-input"
                                    outlined
                                    dense
                                    disabled
                                />
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" md="10">
                    <v-col cols="12" class="text-left ml-0 pl-0">
                        <b>Forecast</b> <span class="text-sm-left blue-grey--text text--lighten-2 thin mt-5">Unit : USD K</span>
                    </v-col>

                    <v-row>
                        <v-col class="d-none d-sm-block">
                            <p class="text-sm-left mt-12 font-weight-light text-black pt-3">Annual revenues</p>
                        </v-col>
                        <!-- First Year -->
                        <v-col cols="12" md="3" class="py-0 my-0">
                            <div class="text-left d-block d-sm-none">
                                <p class="m-0">First Year</p>
                            </div>
                            <v-text-field
                                value="Year 1"
                                background-color="grey"
                                class="years"
                                placeholder="...."
                                outlined
                                dense
                                disabled
                            />
                            <p class="text-sm-left font-weight-light text-black m-0 d-block d-sm-none">Annual revenues</p>
                            <v-text-field
                                v-model="strategy_year1"
                                class="text-bold text-right-input"
                                outlined
                                dense
                                disabled
                            />
                        </v-col>

                        <!-- Second Year -->
                        <v-col cols="12" md="3" class="py-0 my-0">
                            <div class="text-left d-block d-sm-none">
                                <p class="m-0">Second Year</p>
                            </div>
                            <v-text-field
                                value="Year 2"
                                background-color="grey"
                                class="years"
                                placeholder="...."
                                outlined
                                dense
                                disabled
                            />
                            <p class="text-sm-left font-weight-light text-black m-0 d-block d-sm-none">Annual revenues</p>
                            <v-text-field
                                v-model="strategy_year2"
                                class="text-bold text-right-input"
                                outlined
                                dense
                                disabled
                            />
                        </v-col>

                        <!-- Third Year -->
                        <v-col cols="12" md="3" class="py-0 my-0">
                            <div class="text-left d-block d-sm-none">
                                <p class="m-0">Third Year</p>
                            </div>
                            <v-text-field
                                value="Year 3"
                                background-color="grey"
                                class="years"
                                placeholder="...."
                                outlined
                                dense
                                disabled
                            />

                            <p class="text-sm-left font-weight-light text-black m-0 d-block d-sm-none">Annual revenues</p>
                            <v-text-field
                                v-model="strategy_year3"
                                class="text-bold text-right-input"
                                outlined
                                dense
                                disabled
                            />
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </div>
    </div>
</template>
<script>
    import FinanceService from "@/store/services/finance.service";
    import BusinessService from "@/store/services/business.service";

    export default {
        props: {
            company_id: Number,
        },
        components : {},

        watch: {
            company_id () {
                this.getAllData()
            }
        },

        data() {
            return {
                investment_all: {},
                investment_finance: null,
                investment_equity: null,
                investment_convertible: null,
                investment_bonds: null,
                investment_bank: null,
                investment_grants: null,
                investment_safe: null,

                result_monthlyRevenue: null,

                result: {
                    firstYear: {
                        year: "",
                    },
                    secondYear: {
                        year: "",
                    },
                    thirdYear: {
                        year: "",
                    },
                },

                result_firstYear_annualRevenues: null,
                result_secondYear_annualRevenues: null,
                result_thirdYear_annualRevenues: null,
                result_firstYear_grossProfit: null,
                result_secondYear_grossProfit: null,
                result_thirdYear_grossProfit: null,
                result_firstYear_ebit: null,
                result_secondYear_ebit: null,
                result_thirdYear_ebit: null,
                result_firstYear_ebitda: null,
                result_secondYear_ebitda: null,
                result_thirdYear_ebitda: null,

                strategy_year1: 0, // int
                strategy_year2: 0, // int
                strategy_year3: 0, // int

                result_postMoneyValuation: null,
            }
        },
        methods: {
            getAllData() {
                FinanceService.getResult(this.company_id).then((res) => {
                        if (res.data) {
                            this.result.firstYear.year  = res.data.firstyear_year;
                            this.result.secondYear.year = res.data.secondyear_year;
                            this.result.thirdYear.year  = res.data.thirdyear_year;

                            this.result_firstYear_annualRevenues  = res.data.firstyear_annual_revenues.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            this.result_secondYear_annualRevenues = res.data.secondyear_annual_revenues.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            this.result_thirdYear_annualRevenues  = res.data.thirdyear_annual_revenues.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                            this.result_firstYear_grossProfit  = res.data.firstyear_gross_profit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            this.result_secondYear_grossProfit = res.data.secondyear_gross_profit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            this.result_thirdYear_grossProfit  = res.data.thirdyear_gross_profit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                            this.result_firstYear_ebit  = res.data.firstyear_ebit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            this.result_secondYear_ebit = res.data.secondyear_ebit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            this.result_thirdYear_ebit  = res.data.thirdyear_ebit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                            this.result_firstYear_ebitda  = res.data.firstyear_ebitda.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            this.result_secondYear_ebitda = res.data.secondyear_ebitda.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            this.result_thirdYear_ebitda  = res.data.thirdyear_ebitda.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                            this.result_monthlyRevenue     = res.data.monthly_revenue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            this.result_postMoneyValuation = res.data.post_money_valuation.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                            this.result.monthlyRevenue     = res.data.monthly_revenue;
                            this.result.postMoneyValuation = res.data.post_money_valuation;
                        }
                })

                FinanceService.getResult(this.company_id).then((res) => {
                    if (res.data) {
                        this.result_monthlyRevenue  = res.data.monthly_revenue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    }
                })

                FinanceService.getInvestment(this.company_id).then((res) => {
                    if(res.data) {
                        this.investment_all=res.data;
                        this.investment_finance = this.investment_all.finance.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        this.investment_equity  = this.investment_all.equity.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        this.investment_convertible = this.investment_all.convertible.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        this.investment_safe    = this.investment_all.safe.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        this.investment_bonds   = this.investment_all.bonds.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        this.investment_bank    = this.investment_all.bank.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        this.investment_grants  = this.investment_all.grants.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    }
                })

                BusinessService.getStrategy(this.company_id).then((res) => {
                    if(res.data){
                        this.strategy = res.data
                        this.strategy_year1 = this.strategy.year1.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        this.strategy_year2 = this.strategy.year2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        this.strategy_year3 = this.strategy.year3.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    }
                }).catch((err) => {
                    console.log("Error: ", err)
                    this.strategy = null;
                });
            }
        },

        mounted () {
            this.getAllData()
        }
    }
</script>